"use client"

import { useEffect } from "react"

type ErrorBoundaryProps = {
  error: Error & { digest?: string }
  reset: () => void
  heading: string
  message: string
}

export default function ErrorBoundary({
  error,
  reset,
  heading,
  message,
}: ErrorBoundaryProps) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-64px)] px-4">
      <div className="max-w-md w-full text-center bg-white border border-gray-200 rounded-lg p-8 shadow-sm">
        <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-brand-primary/10 flex items-center justify-center">
          <svg
            className="w-6 h-6 text-brand-primary"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
            />
          </svg>
        </div>
        <h2 className="text-xl font-semibold text-brand-navy mb-2">
          {heading}
        </h2>
        <p className="text-sm text-gray-600 mb-6">{message}</p>
        <button
          onClick={reset}
          className="inline-flex items-center justify-center px-6 py-2.5 bg-brand-primary text-white text-sm font-medium rounded-md hover:bg-brand-primary-dark transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2"
        >
          Try again
        </button>
      </div>
    </div>
  )
}
